'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._usePresignedUrl = exports._uploadImageCompleted = exports._getPreSignedUrl = exports.uploadImage = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * uploadImage
 * 
 * Gets presigned url and uploads image to S3.
 * @param {string} feis_id 
 * @param {string} product_id 
 * @param {string} imageName
 * @param {string} contentType 
 * @param {File} file
 */
var uploadImage = exports.uploadImage = function uploadImage(feis_id, product_id, imageName, contentType, file) {
  return function (dispatch) {

    var imageNode = {};

    return dispatch(_getPreSignedUrl(feis_id, product_id, imageName, contentType)).then(function (action) {
      imageNode = action.payload;
      return dispatch(_usePresignedUrl(action.payload.preSignedUrl, contentType, file));
    }).then(function (action) {
      return dispatch(_uploadImageCompleted(feis_id, product_id, imageNode));
    });
  };
};

/////////////////////////////////////////////////////////////////////////////////////////////

var _getPreSignedUrl = exports._getPreSignedUrl = function _getPreSignedUrl(feis_id, product_id, imageName, contentType) {
  return function (dispatch) {

    return dispatch(_defineProperty({
      feis_id: feis_id,
      product_id: product_id,
      imageName: imageName,
      contentType: contentType

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/products/' + product_id + '/images',
        method: 'POST',
        data: { name: imageName, contentType: contentType }
      },
      types: ['GET_PRE_SIGNED_URL_START', 'GET_PRE_SIGNED_URL', 'GET_PRE_SIGNED_URL_ERROR']
    }));
  };
};

var _uploadImageCompleted = exports._uploadImageCompleted = function _uploadImageCompleted(feis_id, product_id, image) {
  return {
    feis_id: feis_id,
    product_id: product_id,
    payload: image,
    type: 'UPLOAD_IMAGE'
  };
};

var _usePresignedUrl = exports._usePresignedUrl = function _usePresignedUrl(url, contentType, file) {
  return function (dispatch) {

    return dispatch(_defineProperty({
      url: url,
      contentType: contentType,
      file: file

    }, _middleware.CALL_API, {
      config: {
        url: url,
        method: 'PUT',
        headers: {
          'Content-Type': contentType
        },
        noAuth: true,
        data: file
      },
      types: ['USE_PRESIGNED_URL_START', 'USE_PRESIGNED_URL', 'USE_PRESIGNED_URL_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/uploadImage.js
// module id = 665
// module chunks = 0